/* unplugin-vue-components disabled */import script from "./TagItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagItem.vue?vue&type=script&setup=true&lang=ts"

import "./TagItem.vue?vue&type=style&index=0&id=ed2c89f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed2c89f2"]])

export default __exports__